export var WhereOperator;
(function (WhereOperator) {
    WhereOperator["contains"] = "contains";
    WhereOperator["endsWith"] = "endsWith";
    WhereOperator["eq"] = "eq";
    WhereOperator["equals"] = "equals";
    WhereOperator["gt"] = "gt";
    WhereOperator["gte"] = "gte";
    WhereOperator["is"] = "is";
    WhereOperator["isAnyOf"] = "isAnyOf";
    WhereOperator["isEmpty"] = "isEmpty";
    WhereOperator["isNotEmpty"] = "isNotEmpty";
    WhereOperator["lt"] = "lt";
    WhereOperator["lte"] = "lte";
    WhereOperator["neq"] = "neq";
    WhereOperator["none"] = "none";
    WhereOperator["startsWith"] = "startsWith";
})(WhereOperator || (WhereOperator = {}));
export var LogicOperator;
(function (LogicOperator) {
    LogicOperator["and"] = "and";
    LogicOperator["or"] = "or";
})(LogicOperator || (LogicOperator = {}));
export var FilterType;
(function (FilterType) {
    FilterType["BooleanType"] = "BooleanType";
    FilterType["DateType"] = "DateType";
    FilterType["NumberType"] = "NumberType";
    FilterType["StringType"] = "StringType";
})(FilterType || (FilterType = {}));
export var ColFilterType;
(function (ColFilterType) {
    ColFilterType["boolean"] = "boolean";
    ColFilterType["date"] = "date";
    ColFilterType["number"] = "number";
    ColFilterType["string"] = "string";
    ColFilterType["multiSelect"] = "multiSelect";
})(ColFilterType || (ColFilterType = {}));
export var StringOperations;
(function (StringOperations) {
    StringOperations["contains"] = "contains";
    StringOperations["endsWith"] = "endsWith";
    StringOperations["equals"] = "equals";
    StringOperations["startsWith"] = "startsWith";
    // isEmpty = "isEmpty",
    // isNotEmpty = "isNotEmpty",
})(StringOperations || (StringOperations = {}));
export var NumberOperation;
(function (NumberOperation) {
    NumberOperation["equals"] = "equals";
    NumberOperation["gt"] = "gt";
    NumberOperation["gtOrEquals"] = "gtOrEquals";
    NumberOperation["lt"] = "lt";
    NumberOperation["ltOrEquals"] = "ltOrEquals";
    NumberOperation["notEquals"] = "notEquals";
    // isNotEmpty = "isNotEmpty",
    // isEmpty = "isEmpty",
})(NumberOperation || (NumberOperation = {}));
export var BooleanOperation;
(function (BooleanOperation) {
    BooleanOperation["is"] = "is";
})(BooleanOperation || (BooleanOperation = {}));
export var MultiSelectOperation;
(function (MultiSelectOperation) {
    MultiSelectOperation["is"] = "is";
    MultiSelectOperation["isEmpty"] = "isEmpty";
    MultiSelectOperation["isNot"] = "isNot";
    MultiSelectOperation["isNotEmpty"] = "isNotEmpty";
})(MultiSelectOperation || (MultiSelectOperation = {}));
export var DateOperation;
(function (DateOperation) {
    DateOperation["after"] = "after";
    DateOperation["before"] = "before";
    DateOperation["between"] = "between";
    DateOperation["isEmpty"] = "isEmpty";
    DateOperation["isNotEmpty"] = "isNotEmpty";
    DateOperation["onOrAfter"] = "onOrAfter";
    DateOperation["onOrBefore"] = "onOrBefore";
    DateOperation["relativeToToday"] = "relativeToToday";
})(DateOperation || (DateOperation = {}));
export var Range;
(function (Range) {
    Range["week"] = "week";
    Range["month"] = "month";
    Range["year"] = "year";
})(Range || (Range = {}));
export var Direction;
(function (Direction) {
    Direction["this"] = "this";
    Direction["next"] = "next";
    Direction["past"] = "past";
})(Direction || (Direction = {}));
//# sourceMappingURL=type.js.map